module.exports = __webpack_public_path__ + "static/media/pic23@3x.3d88b394.png";